import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import StyleAuxiliary from '../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import { Headline6, Subtitle2 } from '../UI/MDC/Typography/Typography';
import Icon from '../UI/Icon/Icon';
import { LABEL_POSITIONS } from './_constants';
import formClasses from './Form.module.scss';

/**
 * Wrapper component for inputs which are Formik-compliant.
 * It displays a label, the component, and validation output.
 * @param {*} properties needed by input field including but not limited to label, field, meta, additionalProps
 * @returns {ReactElement} FieldWrapper component
 */
const FieldWrapper = ({ label, meta, additionalProps, ...props }) => {
	const { labelPosition } = additionalProps;
	const { hideErrorMessage } = props;

	return (
		<StyleAuxiliary
			classes={classnames([
				formClasses[
					'form-element' +
						(!!labelPosition ? '--' + labelPosition : '')
				],
			])}
		>
			{!!labelPosition && labelPosition !== LABEL_POSITIONS.NONE ? (
				<Headline6
					htmlFor={
						!!props.field && !!props.field.name
							? props.field.name
							: props.id
							? props.id
							: ''
					}
					className={formClasses['form-element__label']}
				>
					{meta && meta.touched && meta.error ? (
						<Icon
							icon={'block'}
							className={classnames(
								formClasses[
									'form-element__validation-icon--invalid'
								]
							)}
						/>
					) : (
						<Icon
							icon={'check_circle_outline'}
							className={classnames(
								formClasses[
									'form-element__validation-icon--valid'
								]
							)}
						/>
					)}
					{label}
				</Headline6>
			) : null}
			{props.children && typeof props.children === 'function'
				? formik => props.children({ formik: formik })
				: props.children}
			{!hideErrorMessage ? (
				meta && meta.touched && meta.error ? (
					<Subtitle2
						className={classnames(
							formClasses['form-element__error-label']
						)}
					>
						{meta.error}
					</Subtitle2>
				) : null
			) : null}
		</StyleAuxiliary>
	);
};

FieldWrapper.propTypes = {
	label: PropTypes.string.isRequired,
};

export default FieldWrapper;
